import { useEffect } from 'react'
import Image, { type StaticImageData } from 'next/image'
import logo from '@/images/logo.png'
import security from '@/images/ic_security.png'
import img1 from '@/images/1_ar.png'
import img2 from '@/images/2_ar.png'
import img3 from '@/images/3_ar.png'
import img4 from '@/images/4_ar.png'
import img5 from '@/images/5_ar.png'
import img6 from '@/images/6_ar.png'
import img7 from '@/images/7_ar.png'

import styles from '@/styles/index.module.scss'

const featureImages: { src: StaticImageData; alt: string }[] = [
  { src: img1, alt: 'qibla' },
  { src: img2, alt: 'prayer time' },
  { src: img3, alt: 'athan' },
  { src: img4, alt: 'hijri' },
  { src: img5, alt: 'mosques' },
  { src: img6, alt: 'mosques' },
  { src: img7, alt: 'mosques' },
]

export default function Home() {
  useEffect(() => { }, [])

  const handleDownload = () => {
    window.open(
      'https://play.google.com/store/apps/details?id=com.salatiholy.android&referrer=utm_source%3Dofficial_website',
      '_blank'
    )
  }

  return (
    <div className={styles.hm}>
      <div className={styles.logo}>
        <Image src={logo} alt="logo" />
        Inner Light
      </div>

      <h1>دليلك للقبلة وأوقات الصلاة</h1>
      <div className={styles.btn} onClick={handleDownload}>
        تنزيل
      </div>
      <div className={styles.security}>
        <Image src={security} alt="security" />
        <span>تم التحقق من سلامته</span>
      </div>
      <div className={styles.feature}>
        {featureImages.map(({ src, alt }) => (
          <Image key={src.src} src={src} alt={alt} />
        ))}
      </div>
      <footer>
        <div className={styles.link}>
          <a href="/termsOfService.html">Terms of Service</a>
          <span>|</span>
          <a href="/privacyPolicy.html">Privacy Policy</a>
          <span>|</span>
          <a href="/openSourceLicenses.html">Open Source Licenses</a>
        </div>
        <p>{`© ${new Date().getFullYear()} جميع الحقوق محفوظة`}</p>
      </footer>
    </div>
  )
}
